export default __webpack_public_path__ + "static/6_18-1457730aa2918dae5ebf8026c0244285.png";